import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

const styles = {};

function SigniantServerHardware() {
    return (
        <React.Fragment>
            <h3>Hardware</h3>
            <ul>
                <li>
                    <strong>CPU</strong>: Intel Xeon 2 GHz dual-core or better, quad-core recommended
                </li>
                <li>
                    <strong>Memory</strong>: 8 GB, 16 GB recommended
                </li>
                <li>
                    <strong>Disk Space</strong>: 4 GB free space, 40 GB free space recommended
                </li>
                <li>
                    <strong>Network Connection</strong>: 100 Mbps or faster
                </li>
            </ul>
        </React.Fragment>
    );
}

SigniantServerHardware.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SigniantServerHardware);
